<script lang="ts" setup>
import { ULink } from '#components'

defineProps({
  isLink: {
    default: false,
    type: Boolean,
  },
  to: {
    default: '/',
    type: String,
  },
})

const localePath = useLocalePath()
</script>

<template>
  <component
    :is="isLink ? ULink : 'div'"
    class="size-8"
    :to="isLink ? localePath(to) : undefined"
  >
    <UColorModeImage
      class="size-full select-none"
      dark="/images/bases/BaseEmblem/emblem-dark.svg"
      light="/images/bases/BaseEmblem/emblem-light.svg"
    />
  </component>
</template>
